import { withInstall } from '../../utils/sfc2.js';
import BmsUserMenu from './src/bms-user-menu.vue2.js';

const TBmsUserMenu = withInstall(BmsUserMenu);

export { TBmsUserMenu, TBmsUserMenu as default };
//# sourceMappingURL=index2.js.map
